export default {"src":"/_next/static/media/circleCheckmarkLightWithGreenBg_24.195981f2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};